import {
  SPI,
  BaseFieldWidget,
  ViewType,
  ModelFieldType,
  DetailM2MTableFieldWidget,
  Widget
} from '@kunlun/dependencies';
import Comp from './MyFormM2MTableField.vue';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: [
      'deli.platform.promotion.DeliAriesPlatformPromotionPlan',
      'deli.platform.promotion.DeliAriesPlatformPromotionReginPlan',
      'deli.aries.seller.DeliAriesSellerPromotionPlan' // 推广方案
    ],
    name: 'itemDetail',
    widget:'Table',
    viewType: ViewType.Detail,
    ttype: ModelFieldType.ManyToMany
  })
)
export class MyFormM2MTableFieldWidget extends DetailM2MTableFieldWidget {
  initialize(props: any): this {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Reactive()
  get _dataSource() {
    return this.value;
  }

  @Widget.Reactive()
  get _instance() {
    return this.getSelf();
  }

  @Widget.Reactive()
  mountedFlag = false;

  protected mountedProcess(): Promise<void> {
    this.mountedFlag = true;
    return super.mountedProcess();
  }
}
